/**
 * 로그인 링크에서 토큰을 꺼낸다.
 *
 * ## 왜 프래그먼트(`#token=`)를 먼저 보나
 *
 * `?token=...` 은 **서버로 전송된다.** 그래서 ALB·CloudFront 액세스 로그에 평문으로
 * 남고, 그 페이지에서 나가는 요청의 `Referer` 에도 실린다. 비밀번호가 없는 서비스에서
 * 이 토큰은 **유일한 자격증명**이라, 로그를 볼 수 있는 사람은 누구나 남의 계정에
 * 들어갈 수 있게 된다(15분 안에).
 *
 * `#` 뒤는 브라우저가 서버로 **보내지 않는다.** 그래서 메일이 보내는 주소를 그쪽으로
 * 옮겼다(`us-api` `common/smtp.py` `_magic_link`).
 *
 * ## 왜 쿼리스트링도 계속 읽나
 *
 * 바꾸기 **전에 나간 메일**이 15분 동안 살아 있다. 그 링크를 누른 사람이 «쓸 수 없는
 * 링크» 를 보면 안 된다. 그 15분이 지나도 지우지 않는 이유는, 지워서 얻는 것이 없고
 * 잊고 지나간 메일이 언제 눌릴지 모르기 때문이다.
 *
 * ## 왜 꺼내서 두나
 *
 * 컴포넌트 안에 인라인으로 두면 「프래그먼트를 읽는다」를 **눈으로 믿는 수밖에** 없다.
 * 오늘 그렇게 믿었다가 틀린 코드를 두 번 썼다(`shapeError`, `_same_person`).
 */
export const readMagicToken = (search: string, hash: string): string => {
  const fromHash = new URLSearchParams(hash.replace(/^#/, ""));
  const fromQuery = new URLSearchParams(search.replace(/^\?/, ""));
  return fromHash.get("token") ?? fromQuery.get("token") ?? "";
};

/** 주소에 토큰이 남아 있는가. 남아 있으면 지워야 한다. */
export const hasMagicToken = (search: string, hash: string): boolean =>
  readMagicToken(search, hash) !== "";
